module.exports = __webpack_public_path__ + "static/media/sourcesanspro-bolditalic-webfont.60573f53.woff";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/source-sans-pro/sourcesanspro-bolditalic-webfont.woff
// module id = 510
// module chunks = 0